import React from "react";
import Http from "../../../../../services/Http";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { LogoIconWhite } from "../../../../../services/Assets";
import { Modal, Button } from "react-bootstrap";
import './InvitationPage.css'
import { useTranslation } from 'react-i18next';
import '../../../../../i18n';

const InvitationPage = () => {
  const { t } = useTranslation();

 const decodeUserId = (encodedUserId) => {
  try {
    let base64 = encodedUserId
      .replace(/-/g, '+')
      .replace(/_/g, '/');

    // Add padding back if needed
    while (base64.length % 4 !== 0) {
      base64 += '=';
    }

    return atob(base64);
  } catch (error) {
    console.error("Failed to decode user ID:", error, "Original:", encodedUserId);
    return null;
  }
};

  const navigate = useNavigate();
  const params = useParams();
  const encodedUserId = params.encodeduser;
  const id = decodeUserId(encodedUserId);
  const InvitationRequest = async (id, value) => {
    const response = await Http.post("/auth/invitation-accept", { id, value });
    if (response.status) {
      toast.success(t("Response sent successfully"));
      navigate('/');
    } else {
      toast.error(t("Error accepting invitation"));
    }
  };

  return (
    <Modal show centered className="modal-lg">
      <Modal.Header className="d-flex justify-content-start invi-header">
        <img src={LogoIconWhite} className="modal-img" alt="logo" />
      </Modal.Header>
      <Modal.Body className="text-center py-4">
        <p className="mb-0 fw-400 text-center text-dark invi-text">
          {t("Please accept your invitation to become a team member")}
        </p>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center">
        <Button
          variant="primary"
          onClick={() => InvitationRequest(id, 1)}
          disabled={!id}
          className="d-flex align-items-end"
        >
          <i className="fa-solid fa-check me-2"></i> {t("Accept")}
        </Button>
        <Button
          variant="danger"
          onClick={() => InvitationRequest(id, 0)}
          disabled={!id}
          className="d-flex align-items-center"
        >
          <i className="fa-solid fa-times me-2"></i> {t("Ignore")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InvitationPage;